import is from '@sindresorhus/is';
import { useSearchParams } from 'react-router';

import { useJobArchitectures } from '../api/use-job-architectures';
import { useResolveTargetArchitectureId } from '../select-page/use-resolve-target-architecture-id';

/** The architecture the task views read; with `queriesEnabled` off it reads nothing and resolves to none. */
export const useTaskManagementArchitecture = ({
    queriesEnabled = true,
}: {
    readonly queriesEnabled?: boolean;
} = {}) => {
    const [searchParams] = useSearchParams();
    const architectureIdFromUrl = searchParams.get('architectureId');
    const targetArchitectureId = useResolveTargetArchitectureId({ queriesEnabled });
    const { data: architectures, isPending, isError } = useJobArchitectures({ enabled: queriesEnabled });

    if (
        is.nonEmptyString(architectureIdFromUrl) &&
        (architectures?.some((architecture) => architecture.id === architectureIdFromUrl) ?? false)
    ) {
        return { architectureId: architectureIdFromUrl, isPending, isError };
    }

    return { architectureId: targetArchitectureId ?? undefined, isPending, isError };
};
